<template lang="pug">
	section.section.main-section
		.container
			title-comp(:name="$t('title.recovery_password')")
			.form-container.form-login
				.has-text-centered.is-unselectable.margin-bottom-md
					| {{ $t("auth.password_forget_desc") }}

				.field
					p.control.has-icons-left
						input.input(
							type="email"
							:placeholder="$t('placeholder.email')"
							v-model="email"
							v-on:keyup.enter="submitOrTabLogin")
						span.icon.is-small.is-left
							mail-icon(size="1.5x")

				.field.margin-top-md
					p.control.has-text-centered
						button.button.is-primary(type="button" v-bind:class="buttonClass" @click="submitLogin")
							| {{ $t('button.continue') }}

				article.message.is-danger(v-if="errorEmail" transition="fade")
					.message-body
						| {{ $t('alert.missing_email') }}
				article.message.is-danger(v-else-if="errorAuth" transition="fade")
					.message-body
						| {{ $t('alert.invalid_login') }}

			.form-container.form-login.margin-top-xs(style="background-color:transparent;padding:0 !important;box-shadow:none;border:0;text-align:right;")
				router-link(to="/")
					span.icon.icon-left.feather
						chevron-left-icon
					| {{ $t('button.back_home') }}
</template>

<script>
import TitleComponent from '../components/TitleComponent.vue'
import { MailIcon, LockIcon, EyeOffIcon, EyeIcon, GiftIcon, ChevronLeftIcon } from 'vue-feather-icons'

export default {
	components: {
		TitleComp: TitleComponent,
		ChevronLeftIcon,
		MailIcon,
		LockIcon,
		GiftIcon,
		EyeOffIcon,
		EyeIcon
	},
	data() {
		return {
			loadingLogin : false,
			email        : '',
			errorEmail   : false,
			errorAuth    : false
		}
	},
	props: {
		embedded: Boolean,
		showing : Boolean
	},
	computed: {
		accessToken() {
			return this.$store.state.auth.accessToken
		},
		passwordToken() {
			return this.$store.state.auth.passwordToken
		},
		loading() {
			return this.$store.state.auth.loading
		},
		buttonClass() {
			return { 'is-loading': this.loading }
		}
	},
	mounted() {
		this.$meta().setOptions({ title: this.$t("title.recovery_password") + ' | ' + this.$t("title.home") })
		if (this.accessToken) {
			console.warn('Already logged in')
			this.$router.replace('/profile')
		}

		if (!this.embedded || (this.embedded && this.showing)) this.$store.dispatch('auth/getPasswordToken')
	},
	methods: {
		submitOrTabLogin() {
			this.submitLogin()
		},
		submitLogin() {
			if (this.loadingLogin) return
			if (!this.email || this.email.indexOf('@') === -1 || this.email.indexOf('.') === -1) {
				this.errorEmail = true
				return
			}

			this.loadingLogin = true
			this.$store.dispatch('auth/submitPasswordRecover', { email: this.email })
				.then(response => {
					if (response) {
						//this.$emit('submit')
						this.email = ''
						this.$router.replace('/password-restore-confirm')
					}
				})
				.catch(err => {
					this.loadingLogin = false
					if (err.response && err.response.status) {
						switch (err.response.status) {
							case 403:
								this.errorAuth = true
								break
							case 500:
								this.errorPage = true
								break
							default:
								console.warn(err.response.status)
						}
					}
				})
		}
	},
	watch: {
		email() {
			this.errorEmail = false
			this.errorAuth = false
		},
		showing() {
			if (this.embedded && this.showing) this.$store.dispatch('auth/getPasswordToken')
		}
	}
}
</script>
